<script>

    import Markdown from '../Markdown.svelte';

    let { item } = $props();

</script>

{#if item.description}
    <div class='text'>
        <Markdown source={item.description} />
    </div>
{/if}

<style>

    .text {
        margin: 1rem 0;
        font-size: 0.9rem;
    }

</style>
